import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StatusComp from "../../../components/StatusComp";
import SelectBox from "../../../components/SelectBox";
import { post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import moment from "moment/moment";
import UserReportPage from "./UserReportPage";
import CommonDatePickerReports from "../../../components/CommonDatePickerReports";
import toast from "react-hot-toast";

// import { companyDetails, groupUsers, siteDetails } from '../../constants/redux/api/dummyJson'

const UserReport = () => {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);

  const [cameraList, setCameraList] = useState([]);
  const [camTypes, setCamTypes] = useState([]);
  const [selecetdCam, setSelectedCam] = useState(null);

  const [siteData, setSiteData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [reportData, setReportData] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);

  const location = useLocation();
  const type = location?.state?.type;

  const data = location.state?.data;

  const createdAt = moment().format("DD-MM-YYYY");
  const [comapanyList, setCompanyList] = useState([]);
  const [siteList, setSiteList] = useState([]);

  const getCompanyList = () => {
    post(URL.COMPANY_LIST_ADMIN, {})
      .then((res) => {
        setCompanyList(res?.companies);
        setSiteList([]);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company_id) => {
    let formdata = new FormData();
    setSelectedCompany(company_id);
    setReportData({});
    setSelectedOption([]);
    formdata.append("company_id", company_id?.value);
    post(URL.ACTIVE_ADMIN_SITE, formdata)
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        } else {
          setSiteList([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  const handlePreview = () => {
    if (!selectedCompany?.value) {
      toast.error("Please Select Company");
      return;
    }

    if (!selectedOption?.value) {
      toast.error("Please Select Site");
      return;
    }

    if (!fromDate) {
      toast.error("Please Select From Date");
      return;
    }

    if (!toDate) {
      toast.error("Please Select To Date");
      return;
    }

    let formdata = new FormData();
    formdata.append("from_date", moment(fromDate).format("YYYY-MM-DD"));
    formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    formdata.append("site_id", selectedOption?.value);

    if (selecetdCam?.value) {
      formdata.append("camera_id", selecetdCam?.value);
    }

    post(URL.GET_USER_REPORT_ADMIN, formdata)
      .then((res) => {
        if (res?.data) {
          setReportData(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getCameraList = (site_id) => {
    let formdata = new FormData();
    formdata.append("site_id", site_id?.value);
    post(URL.CAMERA_LISTS_ADMIN, formdata)
      .then((res) => {
        if (res?.cameras?.length > 0) {
          let temp = [];
          res?.cameras?.map((item, ind) => {
            let obj_ = {
              ...item,
              name_old: item?.name,
              name: `${item?.code} - ${item?.name}`,
            };
            temp.push(obj_);
          });
          setCameraList(temp);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"User"} type={"Report"} hide={true} />
      <div className={`d-flex col-md-12 ${type ? "gap-5" : "ac-jb"}`}>
        {/* Company Select */}
        {!type && (
          <div className="col-md-2">
            <label className="form-label">Select Company</label>
            <SelectBox
              arrayData={comapanyList}
              data={company}
              setData={setCompany}
              selectedOption={selectedCompany}
              setSelectedOption={getSiteList}
              style={true}
            />
          </div>
        )}

        {/* Site Select */}
        {!type && (
          <div className="col-md-2">
            <label className="form-label">Select Site</label>
            <SelectBox
              arrayData={siteList}
              data={siteData}
              setData={setSiteData}
              selectedOption={selectedOption}
              setSelectedOption={(val) => {
                setSelectedOption(val);
                getCameraList(val);
                setReportData({});
              }}
              disabled={selectedCompany?.label ? false : true}
              style={true}
            />
          </div>
        )}
        <CommonDatePickerReports
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={(even) => {
            setFromDate(even);
            setReportData({});
          }}
          setToDate={(even) => {
            setToDate(even);
            setReportData({});
          }}
        />
        {/* Preview Button */}
      </div>

      <div className={`d-flex col-md-12 mt-3 gap-5 ac-js`}>
        <div className="col-md-2">
          <label className="form-label">Select Camera</label>
          <SelectBox
            arrayData={cameraList}
            data={camTypes}
            setData={setCamTypes}
            selectedOption={selecetdCam}
            setSelectedOption={(even) => {
              setSelectedCam(even);
              setReportData({});
            }}
            style={true}
          />
        </div>

        <div className="col-md-1 mt-4">
          <button onClick={handlePreview} className="submit-btn">
            Preview
          </button>
        </div>
      </div>
      {/* <div className="mt-3">
        <label className="form-label">Select Group User</label>
        <SelectBox
          arrayData={groupUsers}
          selectedOption={selectedUser}
          setSelectedOption={setSelectedUser}
          style={true}
        />
      </div> */}

      {/* second section */}

      {/* download btn */}
      {reportData?.company && <UserReportPage data={reportData} />}
    </div>
  );
};

export default UserReport;
